<template>
    <div>
        <Card>
            <template #title>
                Contas
            </template>
            <template #content>
                <Toolbar class="mb-2 bg-gray-100">
                    <!-- <template #start>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-file-excel" label="Download" severity="success" size="small"
                                @click="downloadData" />
                        </div>
                    </template> -->
                    <template #start>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-file-excel" label="Download" severity="success" size="small"
                                    @click="downloadData" />
                            <Button v-if="permissoes.CONTAS_INCLUIR" icon="pi pi-plus" label="Inserir por IA" severity="sucess"
                                size="small" @click="openCarneForm()" />
                        </div>
                    </template>
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button v-if="permissoes.CONTAS_INCLUIR" icon="pi pi-plus" label="Incluir" severity="info"
                                size="small" @click="openForm({})" />
                            <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="id_primario" header="ID Primário" sortable></Column>
                    <Column field="id_secundario" header="ID Secundário" sortable></Column>
                    <Column field="valor" header="Valor" sortable>
                        <template #body="{ data }">
                            R$ {{ formatMoney(data.valor) }}
                        </template>
                    </Column>
                    <Column field="data_mam" header="Data MAM" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.data_mam) }}
                            <template v-if="data.data_mam_dias > 0">
                                ({{data.data_mam_dias}} dias)
                            </template>
                        </template>
                    </Column>
                    <Column field="data_vencimento" header="Vencimento" sortable>
                        <template #body="{ data }">
                            {{ dateFormat(data.data_vencimento) }}
                            <template v-if="data.data_vencimento_dias > 0">
                                ({{data.data_vencimento_dias}} dias)
                            </template>
                        </template>
                    </Column>
                    <Column field="cliente" header="Cliente" sortable></Column>
                    <Column field="provedor" header="Provedor" sortable></Column>
                    <Column field="site" header="Site/Localidade" sortable></Column>


                    <Column style="width: 180px"
                        bodyClass="flex justify-content-end gap-1">

                        <template #body="{ data }">
                            <Badge :value="data.boleto_id ? 'CB' : 'SB'" :severity="data.boleto_id ? 'success' : 'danger'" v-tooltip.top="data.boleto_id ? 'Com Boleto' : 'Sem Boleto'" >
                            </Badge>
                            <Badge :value="data.comprovante_id ? 'CC' : 'SC'" :severity="data.comprovante_id ? 'success' : 'danger'" v-tooltip.top="data.comprovante_id ? 'Com Comprovante' : 'Sem Comprovante'" >
                            </Badge>
                            <Badge :value="data.data_pagamento ? '$' : '$'" :severity="data.data_pagamento ? 'success' : 'danger'" v-tooltip.top="data.data_pagamento ? 'Pago' : 'Pendente'" >
                            </Badge>
                            <Button v-if="permissoes.CONTAS_EDITAR" icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                                @click="openForm(data)" />
                            <Button v-if="permissoes.CONTAS_REMOVER" icon="pi pi-trash" title="Remover" severity="danger" size="small"
                                @click="remove(data)" />
                        </template>
                    </Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>

        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-4">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="contrato" v-model="params.filter.contrato" class="w-full" />
                                <label for="contrato">ID Primário e Secundário </label>
                            </FloatLabel>
                        </div>

                        <div class="list-none p-0 m-0 flex flex-col gap-2">
                            <div class="field mt-1 w-full">
                                <FloatLabel>
                                    <AutoComplete 
                                        id="cliente"
                                        v-model="selectedClientes" 
                                        :suggestions="clienteSuggestions"
                                        @complete="searchClientes"
                                        @item-select="onClienteSelect"
                                        optionLabel="nome"
                                        :multiple="true"
                                        class="w-full"
                                        inputClass="w-full"
                                    >
                                        <template #chip="{ value }">
                                            <div 
                                                class="inline-flex items-center gap-2 px-2 py-1 mr-2 my-1 text-sm rounded border align-middle"
                                                :class="value.exclude ? 'bg-red-50 text-red-700 border-red-200' : 'bg-blue-50 text-blue-700 border-blue-200'"
                                            >
                                                <i 
                                                    :class="[
                                                        value.exclude ? 'pi pi-ban' : 'pi pi-check-circle',
                                                        'cursor-pointer hover:scale-110 transition-transform flex-shrink-0'
                                                    ]"
                                                    @click.stop="toggleClienteExclude(value)"
                                                    title="Alternar Incluir/Excluir"
                                                ></i>
                                                
                                                <span 
                                                    class="font-medium select-none block" 
                                                    style="max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                                    :title="value.nome"
                                                >
                                                    {{ value.nome }}
                                                </span>
                                                
                                                <div 
                                                    class="w-px h-3 mx-1 opacity-40 flex-shrink-0"
                                                    :class="value.exclude ? 'bg-red-700' : 'bg-blue-700'"
                                                ></div>

                                                <i 
                                                    class="pi pi-times cursor-pointer hover:font-bold hover:bg-black/5 rounded-full p-0.5 transition-colors flex-shrink-0"
                                                    @click.stop="removeCliente(value)"
                                                    title="Remover"
                                                ></i>
                                            </div>
                                        </template>
                                    </AutoComplete>
                                    <label for="cliente">Cliente</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1 w-full">
                                <FloatLabel>
                                    <InputText id="provedor" v-model="params.filter['pro.nome']" class="w-full" />
                                    <label for="provedor">Provedor</label>
                                </FloatLabel>
                            </div>
                        </div>
                        <div class="list-none p-0 m-0 flex flex-col gap-1">
                            <div class="field mt-1 w-full">
                                <FloatLabel>
                                    <InputText id="site" v-model="params.filter['con.site']" class="w-full" />
                                    <label for="site">Site/Localidade</label>
                                </FloatLabel>
                            </div>

                            <div class="field mt-1 w-full">
                                <FloatLabel>
                                    <Select v-model="params.filter.pago"
                                            :options="[
                                                { id: 1, boleto: 'Pago' },
                                                { id: 2, boleto: 'Pendente' }
                                            ]"
                                            optionLabel="boleto"
                                            optionValue="id"
                                            showClear
                                            class="w-full"
                                            />
                                    <label>Situação Pagamento</label>
                                </FloatLabel>
                            </div>

                        </div>


                        <div class="list-none p-0 m-0 flex flex-col gap-1">

                            <div class="field mt-1  w-full">
                                <FloatLabel>
                                    <Select v-model="params.filter.boleto"
                                            :options="[
                                                { id: 1, boleto: 'Com Boleto' },
                                                { id: 2, boleto: 'Sem Boleto' }
                                            ]"
                                            optionLabel="boleto"
                                            optionValue="id"
                                            showClear
                                            class="w-full"
                                            />
                                    <label>Situação Boleto</label>
                                </FloatLabel>
                            </div>

                            <div class="field mt-1  w-full">
                                <FloatLabel>
                                    <Select v-model="params.filter.comprovante"
                                            :options="[
                                                { id: 1, comprovante: 'Com Comprovante' },
                                                { id: 2, comprovante: 'Sem Comprovante' }
                                            ]"
                                            optionLabel="comprovante"
                                            optionValue="id"
                                            showClear
                                            class="w-full"
                                            />
                                    <label>Situação Comprovante</label>
                                </FloatLabel>
                            </div>
                        </div>

                        <div class="list-none p-0 m-0 flex flex-col gap-1">
                            <div class="field mt-1 w-6">
                                <FloatLabel>
                                    <DatePicker id="data_vencimento_inicio" v-model="params.filter.data_vencimento_inicio"
                                        showIcon class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="data_vencimento_inicio">Vencimento Inicio</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1 w-6">
                                <FloatLabel>
                                    <DatePicker id="data_vencimento_fim" v-model="params.filter.data_vencimento_fim" showIcon
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="data_vencimento_fim">Vencimento Fim</label>
                                </FloatLabel>
                            </div>
                        </div>


                        <div class="list-none p-0 m-0 flex flex-col gap-1">
                            <div class="field mt-1 w-6">
                                <FloatLabel>
                                    <DatePicker id="data_mam_inicio" v-model="params.filter.data_mam_inicio"
                                        showIcon class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="data_mam_inicio">MAM Inicio</label>
                                </FloatLabel>
                            </div>
                            <div class="field mt-1 w-6">
                                <FloatLabel>
                                    <DatePicker id="data_mam_fim" v-model="params.filter.data_mam_fim" showIcon
                                        class="w-full" dateFormat="dd/mm/yy" />
                                    <label for="data_mam_fim">MAM Fim</label>
                                </FloatLabel>
                            </div>
                        </div>
                        <div class="field mt-1">
                            <FloatLabel>
                                <Select v-model="params.filter.data_vencimento_variavel_inicio"
                                        :options="[
                                            { id: 5, vencimentos: '5 dias' },
                                            { id: 10, vencimentos: '10 dias' },
                                            { id: 15, vencimentos: '15 dias' },
                                            { id: 20, vencimentos: '20 dias' }
                                        ]"
                                        optionLabel="vencimentos"
                                        optionValue="id"
                                        showClear
                                        class="w-full" />
                                <label>Vencimentos</label>
                            </FloatLabel>
                        </div>

                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="codigo_de_barras" v-model="params.filter.codigo_de_barras" class="w-full" />
                                <label for="codigo_de_barras">Código de Barras</label>
                            </FloatLabel>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>
        </Popover>

        <ContaForm :visible="visibleForm" :data="item" @close="closeForm" @save="loadData" />
        <CarneForm :visible="visibleCarneForm" :data="item" @close="closeForm" @save="loadData" />
    </div>
</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import Badge from 'primevue/badge';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import Select from 'primevue/select';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import DatePicker from 'primevue/datepicker';
import AutoComplete from 'primevue/autocomplete';
import Checkbox from 'primevue/checkbox';

import Conta from '@/service/conta.js';
import Cliente from '@/service/cliente.js';

import ContaForm from '@/page/conta/Form.vue';
import CarneForm from '@/page/conta/CarneForm.vue';
import ContratoForm from '@/page/contrato/Form.vue';


import Filter from '@/utils/Filter.js';
import File from '@/utils/File.js';
import Mask from '@/utils/Mask.js';

import Moment from 'moment';

export default {
    components: {
        Card,
        Toolbar,
        Badge,
        Button,
        DataTable,
        Paginator,
        Column,
        DatePicker,
        Select,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        AutoComplete,
        Checkbox,

        /* Form */
        ContaForm,
        ContratoForm,
        CarneForm,
    },
    data() {
        return {
            permissoes: permissoes,
            lista: [],
            isLoading: false,
            item: {},
            visibleForm: false,
            visibleCarneForm: false,

            // AutoComplete clientes
            selectedClientes: [],
            clienteSuggestions: [],

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    beforeMount() {
        this.pagination.page = parseInt(this.$route.query.page || 0);
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadData();
    },
    methods: {

        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        openCarneForm(item) {
            this.item = { ...item };
            this.visibleCarneForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
            this.visibleCarneForm = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Conta.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        // AutoComplete clientes
        searchClientes(event) {
            const query = event.query;
            Cliente.search(query)
                .then(response => {
                    // Filtra itens que já estão selecionados
                    const selectedIds = this.selectedClientes.map(c => c.id);
                    this.clienteSuggestions = response.data.filter(c => !selectedIds.includes(c.id));
                })
                .catch(error => {
                    console.error('Erro ao buscar clientes:', error);
                    this.clienteSuggestions = [];
                });
        },
        onClienteSelect(event) {
            // Define padrão como 'incluir' (exclude = false)
            // Precisamos garantir reatividade ao adicionar a propriedade
            if(event.value && typeof event.value.exclude === 'undefined'){
                event.value.exclude = false;
            }
        },
        toggleClienteExclude(cliente) {
            // Alterna entre incluir e excluir
            cliente.exclude = !cliente.exclude;
        },
        removeCliente(cliente) {
            this.selectedClientes = this.selectedClientes.filter(c => c.id !== cliente.id);
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Cliente filtro (AutoComplete Múltiplo)
            if (this.selectedClientes && this.selectedClientes.length > 0) {
                const incluir = [];
                const excluir = [];

                this.selectedClientes.forEach(c => {
                    if (c.exclude) {
                        excluir.push(c.id);
                    } else {
                        incluir.push(c.id);
                    }
                });

                if (incluir.length > 0) {
                    params.push(`filter[cliente_id]=${incluir.join(',')}`);
                }
                
                if (excluir.length > 0) {
                    params.push(`filter[exclude_cliente_id]=${excluir.join(',')}`);
                }
            }

            // Order
            if(['id'].indexOf(this.params.sort.field)>= 0){
                params.push(`order[cont.${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));

            }
            else{
                params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            }

            return params;
        },
        downloadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Conta.download(params.join("&"))
                .then(response => {
                    File.downloadBlob(response);
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Conta.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.selectedClientes = [];
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },

        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY");
        },

        formatMoney(valor) {
            if (!valor) return Mask.money(0);
            return Mask.money(valor);
        },
    }


}
</script>
